/**
 * MH Components Barrel Export
 *
 * This is the single entry point for all Mindhunters governance-compliant components.
 * All features/pages MUST import from this file, never from design-system primitives directly.
 *
 * Layer 3: MH Components (Governance Layer)
 * - Wraps design-system primitives
 * - Applies governance rules (Room System, Core UI Kit)
 * - Enforces brand compliance
 *
 * Components will be added here ON DEMAND as they are created.
 */

// Containers
export { MHContainer, mhContainerVariants } from './containers/MHContainer';
export type { MHContainerProps } from './containers/MHContainer';

// Panels
export { MHPanel, mhPanelVariants } from './panels/MHPanel';
export type { MHPanelProps } from './panels/MHPanel';

// Cards
export {
  MHCard,
  MHCardHeader,
  MHCardFooter,
  MHCardTitle,
  MHCardDescription,
  MHCardContent,
  mhCardVariants,
} from './cards/MHCard';
export type { MHCardProps } from './cards/MHCard';
// export { DecisionCard } from './cards/DecisionCard';

// Buttons
export { MHButton } from './buttons/MHButton';
export type { MHButtonProps } from './buttons/MHButton';

// Overlays
// export { MHOverlay } from './overlays/MHOverlay';

// Indicators
// export { MHBadge } from './indicators/MHBadge';
// export { MHRiskPill } from './indicators/MHRiskPill';
// export { MHConfidence } from './indicators/MHConfidence';

// Brand
export { MHLogoDots } from './MHLogoDots';
export { MHWordmark } from './brand/MHWordmark';

// Layout
export { MHStack, mhStackVariants } from './layout/MHStack';
export type { MHStackProps } from './layout/MHStack';
export { MHGrid, MHGridItem, mhGridVariants, mhGridItemVariants } from './layout/MHGrid';
export type { MHGridProps, MHGridItemProps, MHGridPreset, MHGridArea } from './layout/MHGrid';
export { MHPage } from './layout/MHPage';
export type { MHPageProps } from './layout/MHPage';

// Forms
export { MHInput, MHFloatingLabelInput } from './forms/MHInput';
export { FloatingInput } from './forms/FloatingInput';
export type { FloatingInputProps } from './forms/FloatingInput';
export type { MHInputProps, MHFloatingLabelInputProps } from './forms/MHInput';
export { MHTextarea } from './forms/MHTextarea';
export type { MHTextareaProps } from './forms/MHTextarea';
export { MHSelect, MHSelectTrigger, MHSelectContent, MHSelectItem, MHSelectValue } from './forms/MHSelect';
// export { MHSwitch } from './forms/MHSwitch';

// Indicators
export { MHBadge } from './indicators/MHBadge';
export type { MHBadgeProps } from './indicators/MHBadge';
export { MHAvatar } from './indicators/MHAvatar';
export type { MHAvatarProps } from './indicators/MHAvatar';
export { MHSkeleton } from './indicators/MHSkeleton';
export type { MHSkeletonProps } from './indicators/MHSkeleton';

// Overlays
export { MHDialog } from './overlays/MHDialog';
export type { MHDialogProps } from './overlays/MHDialog';
export { MHDropdown } from './overlays/MHDropdown';
export type { MHDropdownProps, MHDropdownItem } from './overlays/MHDropdown';
export { MHSheet, MHSheetContent } from './overlays/MHSheet';

// Typography
export { MHLink } from './typography/MHLink';
export type { MHLinkProps } from './typography/MHLink';

// Feedback
export { MHDivider } from './feedback/MHDivider';
export type { MHDividerProps } from './feedback/MHDivider';
export { MHToastProvider, useMHToast } from './feedback/MHToast';
export type { MHToastItem } from './feedback/MHToast';

// Icons
export { GoogleIcon } from './icons/GoogleIcon';


// Navigation
export { MHWorkspaceSwitcher } from './navigation/MHWorkspaceSwitcher';
export type { MHWorkspaceOption } from './navigation/MHWorkspaceSwitcher';

// Chat
export { MHChatComposer } from './chat/MHChatComposer';

// OS 2.1 primitives
export { Surface } from './primitives/Surface';
export { Card } from './primitives/Card';
export { SectionHeader } from './primitives/SectionHeader';
export { PrimaryButton } from './primitives/PrimaryButton';
export { SecondaryButton } from './primitives/SecondaryButton';
export { NavItem } from './navigation/NavItem';
